import { DatePicker } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import React from "react";

const { RangePicker } = DatePicker;

const DateRangePicker = React.forwardRef<any, RangePickerProps>(
	(props, ref) => {
		return (
			<RangePicker
				ref={ref}
				format="DD MMM YYYY"
				style={{ width: "100%" }}
				{...props}
			/>
		);
	}
);

DateRangePicker.displayName = "DateRangePicker";

export default DateRangePicker;
